// extracted by mini-css-extract-plugin
export default {"highlightClassName":"CommentHighlightedText_highlightClassName__zAl37"};